/** Detail and help copy for the ticket-service preview. */
export const TICKET_SERVICE_DETAILS: Record<string, [string, string, string]> = {
  'ts.package.name': ['套票名稱', 'Package name', 'セット券名'],
  'ts.package.current': ['目前票券段次', 'Scanned ticket segment', 'スキャンした券の行程'],
  'ts.package.part': ['行程段次', 'Segment', '行程'],
  'ts.package.segment': [
    '第 {number}／{count} 段',
    'Segment {number} of {count}',
    '全{count}行程中の第{number}行程',
  ],
  'ts.package.ticketState': ['票券狀態', 'Ticket status', 'チケットの状態'],
  'ts.package.related': ['關聯票券', 'Related tickets', '関連チケット'],
  'ts.package.scope': [
    '以下為同一訂單、同一套票的其他票券，可能包含同行旅客；各段依出發時間排序。',
    'Other tickets for this package in the same order may include fellow travellers. Segments are ordered by departure time.',
    '同じ注文・セット券の他のチケットです。同行者の分も含まれる場合があります。行程は出発時刻順です。',
  ],
  'ts.package.manualRefund': [
    '此票券屬於套票，機台不提供套票退票。請攜帶套票相關票券洽服務櫃檯，由人員確認各段使用情形與退票方式。',
    'This is a package ticket. Package refunds are handled at the service counter. Bring the related tickets so staff can check usage and refund options.',
    'このチケットはセット券です。端末では払い戻しできません。関連チケットをサービスカウンターへお持ちいただき、各行程の利用状況と払い戻し方法をご確認ください。',
  ],
  'ts.pendingTicket': [
    '退票處理中（尚未退款）',
    'Refund pending; payment not yet returned',
    '払い戻し処理中（未返金）',
  ],
  'ts.voided': ['已作廢，不可登船', 'Voided; cannot board', '無効・乗船不可'],
  'ts.used': ['已使用', 'Used', '使用済み'],
  'ts.method': ['退款方式', 'Refund method', '返金方法'],
  'ts.originalMethod': ['原付款方式', 'Original payment method', '元の決済方法'],
  'ts.paymentState': ['金流狀態', 'Payment status', '返金処理の状態'],
  'ts.paymentPending': ['等待金流確認', 'Awaiting payment confirmation', '決済確認待ち'],
  'ts.paymentDone': ['退款成功', 'Refund confirmed', '返金確認済み'],
  'ts.paymentFailed': ['退款失敗', 'Refund failed', '返金失敗'],
  'ts.invoice': ['發票折讓', 'Invoice adjustment', '請求書調整'],
  'ts.pending': ['處理中', 'Processing', '処理中'],
  'ts.done': ['已完成', 'Complete', '完了'],
  'ts.manual': ['待人工處理', 'Staff review pending', 'スタッフ確認待ち'],
  'ts.stageAccepted': ['申請已受理', 'Request accepted', '申請受付済み'],
  'ts.stagePayment': ['原付款方式退款', 'Refund to original payment method', '元の決済方法に返金'],
  'ts.stageInvoice': ['發票折讓處理', 'Invoice adjustment', '請求書調整'],
  'ts.stageDone': ['全部完成', 'All complete', 'すべて完了'],
  'ts.acceptedNote': [
    '受理不代表款項已入帳。請保留原票券與申請編號，以便再次查詢。',
    'Acceptance does not mean payment has arrived. Keep your original ticket and reference.',
    '受付完了は着金を意味しません。元のチケットと申請番号を保管してください。',
  ],
  'ts.postedNote': [
    '實際入帳時間依付款機構作業。如有疑問，請提供申請編號洽詢。',
    'Posting time depends on your payment provider. Quote your reference when asking for help.',
    '着金時期は決済会社によります。お問い合わせの際は申請番号をお伝えください。',
  ],
  'ts.manualNote': [
    '請保留申請編號並聯繫現場服務人員，請勿重新建立退票申請。',
    'Keep your reference and contact staff. Do not create another refund request.',
    '申請番号を保管し、スタッフにご相談ください。再申請はお控えください。',
  ],
  'ts.failedNote': [
    '是否可登船，請以最新票券狀態與現場人員確認為準。',
    'Confirm the latest ticket status and boarding eligibility with staff.',
    '乗船の可否は最新のチケット状態とスタッフにご確認ください。',
  ],
  'ts.viewProgress': ['查看處理進度', 'View progress', '処理状況を見る'],
  'ts.refresh': ['重新整理', 'Refresh', '更新'],
  'ts.checkOutcome': ['查詢申請結果', 'Check request outcome', '申請結果を確認'],
  'ts.noRepeat': [
    '請勿重複操作，請留在此畫面等候。',
    'Please stay on this screen and avoid repeated actions.',
    'この画面でお待ちください。操作を繰り返さないでください。',
  ],
  'ts.networkNote': [
    '這不是票券無效，也不代表沒有航班。本次查詢不會變更票券狀態。',
    'This does not mean the ticket is invalid or the sailing is unavailable. A query does not change the ticket.',
    'チケット無効や便がないことを意味しません。照会では状態は変わりません。',
  ],
  'ts.notFoundNote': [
    '請重新掃描或核對完整票號。若仍無法查詢，請向服務人員出示票券。',
    'Scan again or check the full ticket number. If needed, show your ticket to staff.',
    '再スキャンまたは番号をご確認ください。確認できない場合はスタッフへ。',
  ],
  'ts.packageNote': [
    '購票機不會拆開套票或取消其中一段，請攜帶整組票券至服務櫃檯。',
    'The kiosk cannot split a package. Bring the complete set of tickets to the service desk.',
    '端末ではセット券を分割できません。全チケットを窓口へお持ちください。',
  ],
  'ts.prepare': ['請準備', 'Please bring', 'お持ちいただくもの'],
  'ts.proof': ['原票券／購票證明', 'Original ticket / proof of purchase', '元のチケット／購入証明'],
  'ts.serviceLocation': ['服務位置', 'Service location', '窓口の場所'],
  'ts.desk': [
    '依現場服務櫃檯指示',
    'Follow the on-site service signs',
    '現地の窓口案内をご確認ください',
  ],
  'ts.helpNote': [
    '目前不提供機台直接呼叫服務人員，請依現場指示前往櫃檯。',
    'This kiosk does not call staff. Please follow the signs to the service desk.',
    'この端末ではスタッフを呼び出せません。案内に従って窓口へお越しください。',
  ],
  'ts.noticeAmount': ['先查看金額，再決定', 'Review the amount first', '金額を確認してから決定'],
  'ts.noticeAmountDesc': [
    '申請前會顯示扣除費用及應退金額。',
    'Deductions and the refund amount are shown before applying.',
    '申請前に控除額と返金額を表示します。',
  ],
  'ts.noticeBoard': ['受理後不能再登船', 'No boarding after acceptance', '受付後は乗船できません'],
  'ts.noticeBoardDesc': [
    '退款需由原付款機構處理，受理不等於入帳。',
    'The payment provider processes your refund; acceptance is not receipt.',
    '返金は決済会社が処理します。受付完了は着金ではありません。',
  ],
  'ts.noticePackage': [
    '套票與特殊情況請洽櫃檯',
    'Ask staff about packages',
    'セット券や特別な事情は窓口へ',
  ],
  'ts.noticePackageDesc': [
    '套票退票需由人員確認完整行程。',
    'Staff must review all parts of the package.',
    'スタッフが行程全体を確認します。',
  ],
  'ts.noticePolicy': [
    '退票資格與金額依該票適用政策計算。無法取得資訊時，請洽服務櫃檯。',
    'Eligibility and amounts depend on the applicable policy. Ask staff if details are unavailable.',
    '払い戻し条件と金額は適用規定によります。情報がない場合は窓口へ。',
  ],
  'ts.continue': ['繼續操作', 'Continue', '操作を続ける'],
  'ts.seconds': ['{count} 秒', '{count} seconds', '{count}秒'],
  'ts.queryProgress': ['查詢退票進度', 'Check refund progress', '払い戻し状況を確認'],
  'ts.stage': ['步驟 {current} / 3', 'Step {current} / 3', 'ステップ {current} / 3'],
};
